export default __webpack_public_path__ + "static/media/en.8aadb914.svg";